import React from 'react'
import { Form } from 'semantic-ui-react'
import { resultTypes } from '../../../common/config'

const resultOptions = Object.keys(resultTypes).map(key => ({ value: key, text: resultTypes[key] }))

const ResultFilter = ({ value, onChange, ...remainingProps }) => {
  const options = [...resultOptions]
  if (!remainingProps.multiple) options.unshift({ value: '', text: 'Vše' })
  let realValue = value
  if (!realValue && remainingProps.multiple) realValue = []
  return (
    <Form.Select
      options={options}
      value={realValue}
      onChange={(e, value) => onChange(value)}
      {...remainingProps}
    />
  )
}

ResultFilter.defaultProps = {
  multiple: false,
  value: '',
}

ResultFilter.propTypes = {
  multiple: React.PropTypes.bool,
  value: React.PropTypes.any,
  onChange: React.PropTypes.func.isRequired,
}

export default ResultFilter



// WEBPACK FOOTER //
// ./src/browser/components/filters/ResultFilter.js